import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Anne Garnier</h1>
            </header>
            <div className="content">
                <p>Réflexologie Intégrative</p>
                <p>06.84.89.60.82</p>
            </div>
        </div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js